import { render, staticRenderFns } from "./WsInfoBelongsToFile.vue?vue&type=template&id=378b6628&"
import script from "./WsInfoBelongsToFile.vue?vue&type=script&lang=js&"
export * from "./WsInfoBelongsToFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports